/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createEducationLevel } from '../fn/education-level/create-education-level';
import { CreateEducationLevel$Params } from '../fn/education-level/create-education-level';
import { deleteEducationLevel } from '../fn/education-level/delete-education-level';
import { DeleteEducationLevel$Params } from '../fn/education-level/delete-education-level';
import { EducationLevel } from '../models/education-level';
import { EducationLevelPagedData } from '../models/education-level-paged-data';
import { getEducationLevel } from '../fn/education-level/get-education-level';
import { GetEducationLevel$Params } from '../fn/education-level/get-education-level';
import { getEducationLevels } from '../fn/education-level/get-education-levels';
import { GetEducationLevels$Params } from '../fn/education-level/get-education-levels';
import { updateEducationLevel } from '../fn/education-level/update-education-level';
import { UpdateEducationLevel$Params } from '../fn/education-level/update-education-level';

@Injectable({ providedIn: 'root' })
export class EducationLevelService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getEducationLevels()` */
  static readonly GetEducationLevelsPath = '/educationlevel';

  /**
   * Gets all education levels.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEducationLevels()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEducationLevels$Response(params?: GetEducationLevels$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationLevelPagedData>> {
    const obs = getEducationLevels(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all education levels.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEducationLevels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEducationLevels(params?: GetEducationLevels$Params, context?: HttpContext): Observable<EducationLevelPagedData> {
    const resp = this.getEducationLevels$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EducationLevelPagedData>): EducationLevelPagedData => r.body)
    );
  }

  /** Path part for operation `createEducationLevel()` */
  static readonly CreateEducationLevelPath = '/educationlevel';

  /**
   * Creates a new education level [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEducationLevel()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createEducationLevel$Response(params?: CreateEducationLevel$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationLevel>> {
    const obs = createEducationLevel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new education level [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEducationLevel$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createEducationLevel(params?: CreateEducationLevel$Params, context?: HttpContext): Observable<EducationLevel> {
    const resp = this.createEducationLevel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EducationLevel>): EducationLevel => r.body)
    );
  }

  /** Path part for operation `getEducationLevel()` */
  static readonly GetEducationLevelPath = '/educationlevel/{id}';

  /**
   * Gets the specified education level.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEducationLevel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEducationLevel$Response(params: GetEducationLevel$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationLevel>> {
    const obs = getEducationLevel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified education level.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEducationLevel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEducationLevel(params: GetEducationLevel$Params, context?: HttpContext): Observable<EducationLevel> {
    const resp = this.getEducationLevel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EducationLevel>): EducationLevel => r.body)
    );
  }

  /** Path part for operation `updateEducationLevel()` */
  static readonly UpdateEducationLevelPath = '/educationlevel/{id}';

  /**
   * Updates the specified education level [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEducationLevel()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateEducationLevel$Response(params: UpdateEducationLevel$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationLevel>> {
    const obs = updateEducationLevel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified education level [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEducationLevel$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateEducationLevel(params: UpdateEducationLevel$Params, context?: HttpContext): Observable<EducationLevel> {
    const resp = this.updateEducationLevel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EducationLevel>): EducationLevel => r.body)
    );
  }

  /** Path part for operation `deleteEducationLevel()` */
  static readonly DeleteEducationLevelPath = '/educationlevel/{id}';

  /**
   * Deletes the specified education level [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEducationLevel()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEducationLevel$Response(params: DeleteEducationLevel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteEducationLevel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified education level [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEducationLevel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEducationLevel(params: DeleteEducationLevel$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteEducationLevel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
